import axios from "axios";
import React, { useState, useEffect, createContext, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState("");

  const fetchToken = async () => {
    try {
      // Form data
      const details = {
        grant_type: "password",
      };
  
      const formBody = new URLSearchParams(details).toString();
  
      // Basic Auth credentials
      const Username = process.env.REACT_APP_JWTUSER;
      const Password = process.env.REACT_APP_JWTPASS;
      const authString = `${Username}:${Password}`;
      const encodedAuth = btoa(authString); // Base64 encode the credentials
  
      const path = "/token";
      const URL = process.env.REACT_APP_BE_URL + path;
  
      console.log("Request URL:", URL);
      console.log("formBody", formBody);
      console.log("Encoded Auth:", encodedAuth);
  
      const response = await axios.post(URL, formBody, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Authorization": `Basic ${encodedAuth}`, // Corrected Authorization header
        },
        withCredentials: true,
      });
  
      if (response.status === 200) {
        const { data } = response;
        console.log("response", data);
        localStorage.setItem("token", data.access_token);
        return { token: data.access_token };
      } else {
        throw new Error("Failed to fetch token");
      }
    } catch (error) {
      console.error("Error fetching token:", error);
      throw error;
    }
  };
  


  useEffect(() => {
    //  Check if token exists in local storage
    const storedToken = localStorage.getItem("token");
    console.log("storedToken", storedToken);
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const authValues = {
    token,
    fetchToken,
  };

  return (
    <AuthContext.Provider value={authValues}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
